import { Translate } from '../../atoms';
import { BodyText, TabContent } from './styles';

export const ConsentTab = ({ isNorthAmerica }: { isNorthAmerica: boolean }) => {
  return (
    <TabContent>
      <BodyText>
        <Translate i18nKey={`components.cookieConsent.${isNorthAmerica ? 'consentTabInfoUS' : 'consentTabInfoEU'}`} />
      </BodyText>
    </TabContent>
  );
};
